import React, { useEffect, useRef, useState } from "react";

/** Real desktop layout, scaled only inside the editor; mobile uses a real 390px canvas. */
export function TemplateViewport({ mobile, children }: { mobile: boolean; children: React.ReactNode }) {
  const container = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(640);
  useEffect(() => {
    if (!container.current) return;
    const observer = new ResizeObserver(entries => setWidth(entries[0].contentRect.width));
    observer.observe(container.current);
    return () => observer.disconnect();
  }, []);
  const canvas = mobile ? 390 : 1280;
  return <div ref={container} style={{ width: "100%", overflow: "hidden" }}><div style={{ width: canvas, zoom: Math.min(width / canvas, 1), margin: "auto" } as React.CSSProperties}>{children}</div></div>;
}
